import { render, staticRenderFns } from "./FieldsetFixedAssetWasteBin.yaml?vue&type=template&id=4be53dc4&component"
import script from "./FieldsetFixedAssetWasteBin.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetFixedAssetWasteBin.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports